import { render, staticRenderFns } from "./Shares.vue?vue&type=template&id=27b0f662&scoped=true"
import script from "./Shares.vue?vue&type=script&lang=js"
export * from "./Shares.vue?vue&type=script&lang=js"
import style0 from "./Shares.vue?vue&type=style&index=0&id=27b0f662&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b0f662",
  null
  
)

export default component.exports